import { Component, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../base-component';
import { AFIntroduction } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ChangeNavigationEvent, ProgressBarEvent, ValidateAndNavigateEvent, SkipToMainContentEvent } from "../service/events";

@Component({
    selector: 'app-introduction',
    templateUrl: './introduction.component.html',
    styleUrls: ['./introduction.component.scss'],
    standalone: false
})

export class IntroductionComponent extends BaseComponent implements OnDestroy, AfterViewInit {

  introData: AFIntroduction;

  constructor(private readonly userService: AuthService, private readonly _router: Router, private readonly eventBus: EventService) {
    super(eventBus, _router);
    this.subscribeEvent();
  }

  subscribeEvent() {
    this.userService.getIntroduction().subscribe((data: AFIntroduction) => {
      this.introData = data;
    });

    this.sub = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        if (event.payload.currentLink === '/introduction') {
          this.eventBus.emit(new ChangeNavigationEvent({ id: event.payload.id }));
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      }
    );

    this.eventBus.emit(new ProgressBarEvent({ id: 100 }));
  }

  ngAfterViewInit() {
    // retain navigation on page refresh
    let navlink = this.userService.getNavLinks().find(e => e.routerLink === '/introduction');
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));

    this.eventBus.on(
      SkipToMainContentEvent,
      (event): void => {
        if (event.payload.text && event.payload.text == "/introduction") {
          let mainContentElement = document.querySelector("#main-content");//check if main-content id exists on page
          if (mainContentElement) {
            mainContentElement.scrollIntoView(true);
          }
        }
      }
    );
  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }


}
